import axios from 'axios';
const LoadingByDest = async (token) => {
  const config = {
    headers: {
      jtoken: token,
    },
  };
  try {
    const { data, status } = await axios.get(
      `${process.env.REACT_APP_HOST}report/weibridge/loading_by_dest`,
      config,
    );

    return { data, status };
  } catch (error) {
    return { data: error.request, status: error.request.status };
  }
};

export default LoadingByDest;
